<template>
  <div class="bom">
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
    <div class="bom-list" v-if="isMasterBom">
      <table>
        <tr>
          <th v-for="n in tableRawNum" v-bind:key="n">
              {{bomHeaderBase[n-1]}}
          </th>
        </tr>
        <tr v-for="(base, index) in bomBaseList" v-bind:key="'base'+index">
          <td v-for="n in tableRawNum" v-bind:key="n">
            {{base[n-1]}}
          </td>
        </tr>
        <tr>
          <th v-for="n in tableRawNum" v-bind:key="n">
              {{bomHeaderProperty[n-1]}}
          </th>
        </tr>
        <tr v-for="(property, index) in bomPropertyList" v-bind:key="'property'+index">
          <td v-for="n in tableRawNum" v-bind:key="n">
            {{property[n-1]}}
          </td>
        </tr>
        <tr>
          <th v-for="n in tableRawNum" v-bind:key="n">
              {{bomHeaderClient[n-1]}}
          </th>
        </tr>
        <tr v-for="(client, index) in bomClientList" v-bind:key="'client'+index">
          <td v-for="n in tableRawNum" v-bind:key="n">
            {{client[n-1]}}
          </td>
        </tr>
        <tr>
          <th v-for="n in tableRawNum" v-bind:key="n">
              {{bomHeaderEstimate[n-1]}}
          </th>
        </tr>
        <tr v-for="(estimate, index) in bomEstimateList" v-bind:key="'estimate'+index">
          <td v-for="n in tableRawNum" v-bind:key="n">
            {{estimate[n-1]}}
          </td>
        </tr>
        <tr>
          <th v-for="n in tableRawNum" v-bind:key="n">
              {{bomHeaderRoom[n-1]}}
          </th>
        </tr>
        <tr v-for="(room, index) in bomRoomList" v-bind:key="'room'+index">
          <td v-for="n in tableRawNum" v-bind:key="n">
            {{room[n-1]}}
          </td>
        </tr>
        <tr v-if="bomHeaderPrice.length > 0">
          <th v-for="n in tableRawNum" v-bind:key="n">
              {{bomHeaderPrice[n-1]}}
          </th>
        </tr>
        <tr v-for="(price, index) in bomPriceList" v-bind:key="'price-'+index">
          <td v-for="n in tableRawNum" v-bind:key="n">
            {{price[n-1]}}
          </td>
        </tr>
        <tr v-if="bomHeaderPrice2.length > 0">
          <th v-for="n in tableRawNum" v-bind:key="n">
              {{bomHeaderPrice2[n-1]}}
          </th>
        </tr>
        <tr v-for="(price2, index) in bomPriceList2" v-bind:key="'price2-'+index">
          <td v-for="n in tableRawNum" v-bind:key="n">
            {{price2[n-1]}}
          </td>
        </tr>
        <tr v-if="bomHeaderFactoryPrice2.length > 0">
          <th v-for="n in tableRawNum" v-bind:key="n">
              {{bomHeaderFactoryPrice2[n-1]}}
          </th>
        </tr>
        <tr v-for="(factoryPrice, index) in bomFactoryPriceList2" v-bind:key="'factoryprice-'+index">
          <td v-for="n in tableRawNum" v-bind:key="n">
            {{factoryPrice[n-1]}}
          </td>
        </tr>
        <tr v-if="bomHeaderProductPrice.length > 0">
          <th v-for="n in tableRawNum" v-bind:key="n">
              {{bomHeaderProductPrice[n-1]}}
          </th>
        </tr>
        <tr v-for="(productPrice, index) in bomProductPriceList" v-bind:key="'productprice-'+index">
          <td v-for="n in tableRawNum" v-bind:key="n">
            {{productPrice[n-1]}}
          </td>
        </tr>
        <!-- <tr v-if=" Object.keys(bomFactoryList).length">
          <th v-for="n in tableRawNum" v-bind:key="n">
              {{bomHeaderFactory[n-1]}}
          </th>
        </tr>
        <tr v-for="(factory, index) in bomFactoryList" v-bind:key="'factory'+index">
          <td v-for="n in tableRawNum" v-bind:key="n">
            {{factory[n-1]}}
          </td>
        </tr> -->
        <tr v-if=" Object.keys(bomFactoryProfitList).length">
          <th v-for="n in tableRawNum" v-bind:key="n">
              {{bomHeaderFactoryProfit[n-1]}}
          </th>
        </tr>
        <tr v-for="(factory, index) in bomFactoryProfitList" v-bind:key="'factoryprofit'+index">
          <td v-for="n in tableRawNum" v-bind:key="n">
            {{factory[n-1]}}
          </td>
        </tr>
        <tr>
          <th v-for="n in tableRawNum" v-bind:key="n">
              {{bomHeaderPlanData[n-1]}}
          </th>
        </tr>
        <tr v-for="(plandata, index) in bomPlanDataList" :key="'pd-'+index">
          <td v-for="n in tableRawNum" v-bind:key="n">
            {{plandata[n-1]}}
          </td>
        </tr>
        <tr>
          <th v-for="n in tableRawNum" v-bind:key="n">
              {{bomHeaderPlanEc[n-1]}}
          </th>
        </tr>
        <tr v-for="(planec, index) in bomPlanEcList" :key="'pe-'+index">
          <td v-for="n in tableRawNum" v-bind:key="n">
            {{planec[n-1]}}
          </td>
        </tr>
        <tr>
          <th v-for="n in tableRawNum" v-bind:key="n">
            {{bomHeaderSpace[n-1]}}
          </th>
        </tr>
        <tr v-for="(space, index) in bomSpaceList" v-bind:key="'space'+index">
          <td v-for="n in tableRawNum" v-bind:key="n">
            {{space[n-1]}}
          </td>
        </tr>
      </table>
    </div>
    <div v-else-if="isEBom" class="data-area">
      <ul>
        <li class="text-title">設計BOM/資材一覧表出力方法</li>
        <li>「設計BOM/資材一覧表」左のチェックボックスをご選択いただき「チェックしたドキュメントの送信」をクリックください。<br>
        自動生成された設計BOM/資材一覧表が添付されたメールが、登録メールアドレス宛に送られます。<br>
        添付エクセル内「設計BOM自動生成」ボタンをクリックすることで、内容をご確認いただけます。
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import * as Api from '../../utils/Api'
import * as App from '../../utils/App'
import {API_URL} from '../../constants/App'
import Modal from '../../components/common/Modal'
import LoadingModal from '../../components/common/LoadingModal'

export default {
  name: 'BomPreview',
  components: {
    'dd-modal': Modal,
    'dd-loading-modal': LoadingModal
  },
  props: {
    orderCode: String,
    rotCode: String,
    spaceJoincd: String,
    isEBom: Boolean,
    isMasterBom: Boolean
  },
  data () {
    return {
      csvDataMap: {},
      bomHeaderBase: [],
      bomBaseList: [],
      bomHeaderProperty: [],
      bomPropertyList: [],
      bomHeaderClient: [],
      bomClientList: [],
      bomHeaderEstimate: [],
      bomEstimateList: [],
      bomHeaderRoom: [],
      bomRoomList: [],
      bomHeaderPrice: [],
      bomPriceList: [],
      bomHeaderPrice2: [],
      bomPriceList2: [],
      bomHeaderFactoryPrice2: [],
      bomFactoryPriceList2: [],
      bomHeaderProductPrice: [],
      bomProductPriceList: [],
      bomHeaderFactory: [],
      bomFactoryList: [],
      bomHeaderFactoryProfit: [],
      bomFactoryProfitList: [],
      bomHeaderSpace: [],
      bomSpaceList: [],
      bomHeaderPlanData: [],
      bomPlanDataList: [],
      bomHeaderPlanEc: [],
      bomPlanEcList: [],
      // テーブルの行数
      tableRawNum: 0,
      imgBom: this.getImage('print/ic_output.svg')
    }
  },
  methods: {
    getBom: function () {
      let urlStr = ''
      if (this.rotCode != null) {
        urlStr = API_URL.PREVIEW + '/manufacture/bom/' + this.rotCode
      } else if (this.$route.query.propertyId != null) {
        urlStr = API_URL.PREVIEW + '/' + this.$route.query.propertyId
      } else if (this.orderCode == null) {
        urlStr = API_URL.PREVIEW + '/bom/' + this.spaceJoincd
      } else {
        urlStr = API_URL.ORDER + '/detail/bom/' + this.orderCode + '/' + this.spaceJoincd
      }
      this.$refs.loadingModalRef.showModal(true)
      axios.get(urlStr)
        .then(response => {
          this.$refs.loadingModalRef.showModal(false)
          console.log('▼▼▼▼ DEBUG:GET BOM DATA ▼▼▼▼')
          console.log(response)
          console.log('▲▲▲▲ DEBUG:GET BOM DATA ▲▲▲▲')
          // レスポンス取得
          let csvDataMap = response.data.data
          console.dir(csvDataMap)
          // BOMの設定
          let baseDataList = csvDataMap.BASE_INFO
          this.bomHeaderBase = baseDataList[0]
          this.bomBaseList = baseDataList.slice(1, baseDataList.length)
          let propertyDataList = csvDataMap.PROPERTY_INFO
          this.bomHeaderProperty = propertyDataList[0]
          this.bomPropertyList = propertyDataList.slice(1, propertyDataList.length)
          let clientDataList = csvDataMap.CLIENT_INFO
          this.bomHeaderClient = clientDataList[0]
          this.bomClientList = clientDataList.slice(1, clientDataList.length)
          let estimateDataList = csvDataMap.ESTIMATE_INFO
          this.bomHeaderEstimate = estimateDataList[0]
          this.bomEstimateList = estimateDataList.slice(1, estimateDataList.length)
          let roomDataList = csvDataMap.ROOM_INFO
          this.bomHeaderRoom = roomDataList[0]
          this.bomRoomList = roomDataList.slice(1, roomDataList.length)
          let priceDataList = csvDataMap.PRICE_INFO
          if (priceDataList && priceDataList.length > 0) {
            this.bomHeaderPrice = priceDataList[0]
            this.bomPriceList = priceDataList.slice(1, priceDataList.length)
          }
          let priceDataList2 = csvDataMap.PRICE_INFO2
          if (priceDataList2 && priceDataList2.length > 0) {
            this.bomHeaderPrice2 = priceDataList2[0]
            this.bomPriceList2 = priceDataList2.slice(1, priceDataList2.length)
          }
          let factoryPriceDataList = csvDataMap.FACTORY_PRICE_INFO
          if (factoryPriceDataList && factoryPriceDataList.length > 0) {
            this.bomHeaderFactoryPrice2 = factoryPriceDataList[0]
            this.bomFactoryPriceList2 = factoryPriceDataList.slice(1, factoryPriceDataList.length)
          }
          let productPriceDataList = csvDataMap.PRODUCT_PRICE_INFO
          if (productPriceDataList && productPriceDataList.length > 0) {
            console.log(productPriceDataList)
            this.bomHeaderProductPrice = productPriceDataList[0]
            this.bomProductPriceList = productPriceDataList.slice(1, productPriceDataList.length)
          }
          // let factoryDataList = csvDataMap.FACTORY_INFO
          // if (factoryDataList && factoryDataList.length > 0) {
          //   this.bomHeaderFactory = factoryDataList[0]
          //   this.bomFactoryList = factoryDataList.slice(1, factoryDataList.length)
          // }
          let factoryProfitList = csvDataMap.FACTORY_PROFIT
          if (factoryProfitList && factoryProfitList.length > 0) {
            this.bomHeaderFactoryProfit = factoryProfitList[0]
            this.bomFactoryProfitList = factoryProfitList.slice(1, factoryProfitList.length)
          }
          let planDataList = csvDataMap.PLAN_DATA_INFO
          this.bomHeaderPlanData = planDataList[0]
          this.bomPlanDataList = planDataList.slice(1, planDataList.length)
          let planEcList = csvDataMap.PLAN_EC_INFO
          this.bomHeaderPlanEc = planEcList[0]
          this.bomPlanEcList = planEcList.slice(1, planEcList.length)
          let spaceDataList = csvDataMap.PLAN_INFO
          this.bomHeaderSpace = spaceDataList[0]
          this.bomSpaceList = spaceDataList.slice(1, spaceDataList.length)

          console.log('bomHeaderBase length: ' + this.bomHeaderBase.length)
          console.log('bomHeaderProperty length: ' + this.bomHeaderProperty.length)
          console.log('bomHeaderClient length: ' + this.bomHeaderClient.length)
          console.log('bomHeaderEstimate length: ' + this.bomHeaderEstimate.length)
          console.log('bomHeaderRoom length: ' + this.bomHeaderRoom.length)
          console.log('bomHeaderPrice length: ' + this.bomHeaderPrice.length)
          // console.log('bomHeaderPrice length: ' + Object.keys(this.priceDataList))
          console.log('bomHeaderPrice2 length: ' + this.bomHeaderPrice2.length)
          console.log('bomHeaderProductPrice length: ' + this.bomHeaderProductPrice.length)
          console.log('bomHeaderPlanData length: ' + this.bomHeaderPlanData.length)
          console.log('bomHeaderPlanEc length: ' + this.bomHeaderPlanEc.length)
          console.log('bomHeaderSpace length: ' + this.bomHeaderSpace.length)

          // テーブルの行数取得
          this.tableRawNum = Math.max(this.bomHeaderBase.length, this.bomHeaderProperty.length, this.bomHeaderClient.length,
            this.bomHeaderEstimate.length, this.bomHeaderRoom.length, this.bomHeaderPlanData.length, this.bomHeaderPlanEc.length,
            this.bomHeaderSpace.length)
          console.log('tableRawNum: ' + this.tableRawNum)
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          Api.handleError(error)
        })
    },
    getImage: function (image) {
      return App.getDarosResource(image)
    }
  },
  mounted: function () {
    console.log('mounted getbom')
    this.getBom()
  }
}
</script>
<style lang="scss" scoped>
.bom {
  display: inline-block;
  width: 100%;
  height: 100%;
  overflow: auto;
}
table {
  width: auto;
  td {
    white-space: nowrap;
    border: 1px solid #ddd;
  }
}
.data-area {
  li {
    padding-top: 24px;
    padding-left: 12px;
    line-height: normal;
  }
  .text-title {
    font-size: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/sheet/BomPreview.vue